module.exports = __webpack_public_path__ + "img/s31_normal.0968977d.svg";